import PublicLayout from "../../layouts/publicLayout";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  FormHelperText,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
  Tooltip,
  Link,
  Divider,
  Modal,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import logo from "./../../assets/images/newLogo.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ComponentBackdrop from "../../components/backdrop";
import { bannedDomains } from "../../data/bannedDomains";
import { passwordRules } from "../../data/passwordRules";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import ForgotPassword from "./forgotpassword";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";
import CloseIcon from "@mui/icons-material/Close";
import PrivacyPolicyModal from "../Policy/details";
import Details from "../Terms/details";
import poisum from "./../../assets/images/poisum.png";

const validateEmail = (value) => {
  if (!value) return "Email is required.";

  const domain = value.split("@")[1];

  if (bannedDomains.includes(domain)) {
    return `Emails from ${domain} are not allowed. Use your work email address.`;
  }

  return ""; // valid
};

const validatePassword = (value) => {
  if (!value) return "Password is required.";
  if (value.length < 8) return "Password must be at least 8 characters";
  if (!/[A-Z]/.test(value))
    return "Password must contain at least one uppercase letter";
  if (!/[a-z]/.test(value))
    return "Password must contain at least one lowercase letter";
  if (!/[0-9]/.test(value))
    return "Password must contain at least one number";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value))
    return "Password must contain at least one special character";
  return "";
};

const PasswordRules = ({ password }) => (
  <Stack spacing={0.5}>
    {passwordRules.map((rule, idx) => {
      const passed = rule.test(password);
      return (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          key={idx}
        >
          {passed ? (
            <CheckCircleIcon
              fontSize="small"
              sx={{ color: "success.main" }}
            />
          ) : (
            <CancelIcon
              fontSize="small"
              sx={{ color: "error.main" }}
            />
          )}
          <Typography
            variant="note"
            sx={{ color: passed ? "success.main" : "error.main" }}
          >
            {rule.label}
          </Typography>
        </Stack>
      );
    })}
  </Stack>
);

const Signin = () => {
  const theme = useTheme();
  const labelWidth = 170;
  const navigate = useNavigate();
  const { apiUrls: { accountMgtApiUrl, mobileApiUrl } } = useApiClient();

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [data, setData] = useState({
    username: "",
    password: "",
    client_id: "poisum-mobile",
  });
  const [errors, setErrors] = useState({
    username: "",
    password: ""
  });
  const [showPassword, setShowPassword] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false)
  const [openTnc, setOpenTnc] = useState(false);
  const [openPolicy, setOpenPolicy] = useState(false);
  useEffect(() => {
    const savedUsername = localStorage.getItem("email");
    if (savedUsername) {
      setData((prev) => ({
        ...prev,
        username: savedUsername,
      }));
    }
  }, []);

  const handleChange = (field, e) => {
    setData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const validate = (name, value) => {
    switch (name) {
      case "username":
      // return validateEmail(value);
      case "password":
      // return validatePassword(value);
      default:
        return "";
    }
  };

  const handleLoginSuccess = async (user) => {

    console.log('mobileApiUrl', mobileApiUrl);

    try {

      const apiBase = mobileApiUrl || process.env.REACT_APP_MOBILE_API_URL;
      if (!apiBase) {
        console.error("mobileApiUrl is missing. Cannot fetch onboarding.");
        toast.error("A system error occurred. Please try again later.", { style: { zIndex: 9999 } });
        navigate("/signin"); // fallback to dashboard
        return;
      }

      const token = localStorage.getItem("token");
      if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      }

      const res = await api.get(`${apiBase}onboarding/onboarding-list`);
      const { dateOfBirth, gender, valuetagName, emailGreeting, addedEmployee } = res.data.data;

      const showOnboarding =
        dateOfBirth != "" &&
        gender != "" &&
        valuetagName.length > 0 &&
        emailGreeting != "" &&
        addedEmployee == true;
        console.log('showOnboarding', showOnboarding);
      // localStorage.setItem("showOnboarding", JSON.stringify(showOnboarding));

      // Redirect based on onboarding status
      if (!showOnboarding) {
        navigate("/summary");
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("Error checking onboarding:", error.message);
      navigate("/");
    }
  };

  const handleClose = (type) => {
    if (type === "tnc") {
      setOpenTnc(false);
    } else if (type === "privacy") {
      setOpenPolicy(false);
    }
  };

  const handleOpen = (type) => {
    if (type === "tnc") {
      setOpenTnc(true);
    } else if (type === "privacy") {
      setOpenPolicy(true);
    }
  };

 const handleSubmit = async (event) => {
  event.preventDefault();

  // Validate input
  const validationErrors = {
    username: validate("username", data.username),
    password: validate("password", data.password),
  };
  setErrors(validationErrors);

  const hasErrors = Object.values(validationErrors).some(Boolean);
  if (hasErrors) {
    toast.error(Object.values(validationErrors).filter(Boolean).join("\n"), { style: { zIndex: 9999 } });
    return;
  }

  if (!accountMgtApiUrl || !mobileApiUrl) {
    toast.error("System configuration error. Please contact administrator.");
    return;
  }

  setOpenBackdrop(true);
  try {
    const response = await api.post(`${accountMgtApiUrl}SourceUser/SourceUserLogin`, data);
    const { access_token, refresh_token, user } = response?.data?.data || {};

    if (!user) {
      toast.error("Invalid user data received.");
      return;
    }

    localStorage.setItem("token", access_token);
    localStorage.setItem("refreshToken", refresh_token);
    localStorage.setItem("employeeId", user.linked_user_id);
    api.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

     const hasPermission = await checkPermissions(user);
    if (!hasPermission) {
      toast.error("You do not have the required permissions to access this portal.");
      return;
    } else {
      // Password reset flow
      if (user.is_reset_password === true || user.is_reset_password === "true" || user.is_reset_password === 1) {
        sessionStorage.setItem("tempPw", data.password);
        toast.success("Password reset required. Redirecting...");
        setTimeout(() => navigate("/resetPassword"), 1500);
        return;
      } else {
        toast.success("Login successful! Redirecting...");
        setTimeout(() => handleLoginSuccess(user), 1500);
      }
    }    
  } catch (error) {
    ErrorAlert(error, navigate);
  } finally {
    setOpenBackdrop(false);
  }
};


const checkPermissions = async (user, requiredRoles = ["Poisum Admin"]) => {
  try {
    const base = mobileApiUrl || process.env.REACT_APP_MOBILE_API_URL;
    if (!base) {
      console.error("checkPermissions: mobileApiUrl missing");
      return false;
    }

    // Ensure auth header if token exists
    const token = localStorage.getItem("token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    const url = `${base.replace(/\/+$/, "")}/user/user-permission`;
    const res = await api.get(url);

    // Normalize payload from different API shapes
    const payload = res?.data?.data ?? res?.data ?? {};

    // Aggregate possible role fields into a Set
    const rolesFound = new Set();

    const addRole = (r) => {
      if (!r && r !== 0) return;
      if (Array.isArray(r)) {
        r.forEach((x) => addRole(x));
      } else if (typeof r === "object") {
        // object like { name: '...' } or { roleName: '...' }
        addRole(r.name ?? r.roleName ?? r.role ?? "");
      } else {
        rolesFound.add(String(r).trim());
      }
    };

    addRole(payload.roleName ?? payload.role ?? payload.roles ?? payload.rolesName);
    addRole(payload.permissions ?? payload.allowedRoles ?? null);

    // Fallback: use the user object provided to the function
    if (user) {
      addRole(user.roleName ?? user.role ?? user.roles ?? null);
    }

    // Compare case-insensitively
    const foundArray = Array.from(rolesFound).filter(Boolean).map((r) => r.toLowerCase());
    const requiredLower = requiredRoles.map((r) => r.toLowerCase());
    const hasPermission = requiredLower.some((req) => foundArray.includes(req));

    return hasPermission;
  } catch (error) {
    console.error("checkPermissions error:", error);
    return false;
  }
};
  
  const handleForgotPasswordClick = () => {
    navigate("/forgot-password"); 
  };

  return (
    <PublicLayout>
        <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%", // Changed from 100vh to 100%
          maxWidth: { xs: "100%", md: 1100 },
          overflowY: "auto",
          boxShadow: { xs: "none", md: "0px 4px 20px rgba(0, 0, 0, 0.1)" },
          backgroundColor: 'background.main',
          borderRadius: { xs: "10px", md: "15px" },
          py: { xs: 4, sm: 8, md: 4 },
          px: { xs: 1, sm: 2, md: 12 },
          mx: { xs: 0, md: 2 },
          minHeight: { xs: "50vh", md: "auto" },
          height: { xs: "100%", sm: "90%", md: "650px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
            gap: { xs: 2, md: 4 }, // Added gap between logo and form
          }}
        >
          {/* Logo Section */}
          <Box
            sx={{
              display: "flex",
              position: "relative",
              borderRadius: "15px",
              p: { xs: 1, sm: 2, md: 4 }, // responsive padding
              width: "100%",
              maxWidth: { xs: 300, sm: 350, md: 400 }, // responsive width
              mx: "auto",
              // boxShadow: 2,
              mt: {xs: 3, sm: 5},
              height: { xs: 120, sm: 180, md: 250 }, // responsive height
              mb: { xs: 3, md: 4 },
            }}
          >
            {/* Faint Logo in Background */}
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: {
                  xs: 100, // smaller on mobile
                  sm: 160,
                  md: 200,
                  lg: 250,
                },
                height: "auto",
                zIndex: 0,
              }}
            />
          </Box>

          <Box
            sx={{
              backgroundColor: "#39483f43",
              borderRadius: '15px',
              py: { xs: 2, sm: 3, md: 4 },
              px: { xs: 2, sm: 4, md: 6 },
              width: { xs: "100%", sm: "90%", md: "380px" },
              height: "auto",
              maxWidth: { xs: "100%", sm: "480px" },
            }}
          >
            <Typography
              variant="title"
              display="block"
              fontWeight={600}
              gutterBottom
              textAlign="center"
              mb={3}
              textTransform={'uppercase'}
              sx={{ color: '#fff' }}
            >
              POISUM portal
            </Typography>

              
            <Typography variant="subtitle" fontWeight={600} gutterBottom  sx={{ color: '#fff' }} textTransform={'uppercase'}  display="block">
              Login
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              autoComplete="off"
            >
              <Stack spacing={2} width="100%">
                {/* Email Field */}
                <Box>
                  <Typography variant="body" sx={{ mb: 1, fontWeight: 500, color: "#fff" }} display="block">
                    Email
                  </Typography>
                  <TextField
                    id="username"
                    name="email"
                    type="email"
                    disabled
                    value={data.username}
                    onChange={(e) => handleChange("username", e)}
                    error={!!errors.username}
                    helperText={errors.username}
                    slotProps={{
                      input: {
                        autoComplete: "off",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Change email" arrow>
                              <IconButton
                                onClick={() => navigate(-1)}
                                edge="end"
                              >
                                <ArrowBack />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      },
                    }}
                    size="normal"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                        borderRadius: 2,
                        "& fieldset": {
                          borderColor: "transparent",
                        },
                        "&:hover fieldset": {
                          borderColor: "primary.light",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                  />
                </Box>

                {/* Password Field */}
                <Box>
                  <Typography variant="body" sx={{fontWeight: 500, color: "#fff" }} display="block">
                    Password
                  </Typography>
                  <TextField
                    autoFocus
                    placeholder="Enter your password"
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={data.password}
                    onChange={(e) => handleChange("password", e)}
                    error={!!errors.password}
                    helperText={
                      errors.password === "Password is required." ||
                        data.password === ""
                        ? errors.password
                        : ""
                    }
                    size="normal"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                        borderRadius: 2,
                        "&:hover fieldset": {
                          borderColor: "primary.light",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                    autoComplete="off"
                    slotProps={{
                      input: {
                        autoComplete: 'off',
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title={!showPassword ? 'Show Password' : 'Hide Password'} arrow>
                              <IconButton
                                onClick={() => setShowPassword((prev) => !prev)}
                                edge="end"
                              >
                                {!showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Box>

                {/* Forgot Password and Validation */}
                <Box sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  // gap: 2,
                }}>
                  {/* Password validation rules */}
                  {data.password && errors.password && (
                    <Box sx={{ flex: 1 }}>
                      <PasswordRules password={data.password} />
                    </Box>
                  )}

                  {/* Forgot Password button */}
                  <Box sx={{
                    textAlign: { xs: "left", sm: "right" },
                    width: { xs: "100%", sm: "auto" }
                  }}>
                    <Button
                      variant="text"
                      sx={{
                        fontSize: 12,
                        textTransform: "none",
                        minWidth: "auto",
                        padding: 0,
                        whiteSpace: "nowrap",
                        color: "#fff"
                      }}
                      onClick={handleForgotPasswordClick}
                    >
                      Forgot Password?
                    </Button>
                  </Box>
                </Box>

                {/* Sign In Button */}
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    backgroundColor: "primary.main",
                    mt: 2,
                    py: 1.5,
                    textTransform: "capitalize",
                    fontSize: 14
                  }}
                >
                  Sign In
                </Button>
                {/* <Box sx={{
                  mt: 1,
                  textAlign: { xs: "left", sm: "center" },
                  width: { xs: "100%", sm: "auto" }
                }}>
                  <Typography
                    variant="text"
                    sx={{
                      fontSize: 12,
                      textTransform: "none",
                      minWidth: "auto",
                      padding: 0,
                      whiteSpace: "nowrap",
                      color: "#fff"
                    }}
                  >
                    or continue with
                  </Typography>
                </Box> 
                <Box sx={{
                  mt: 1,
                  textAlign: { xs: "left", sm: "center" },
                  width: { xs: "100%", sm: "auto" }
                }}>
                   <Typography
                    variant="text"
                    sx={{
                      fontSize: 10,
                      textTransform: "none",
                      minWidth: "auto",
                      padding: 0,
                      whiteSpace: "nowrap",
                      color: "#fff"
                    }}
                  >
                    Don't have an account yet?
                  </Typography>

                 <Link
                    component={RouterLink}
                    to="/signup"
                    sx={{
                      marginLeft: 0.5,
                      color: "#fff",
                      fontSize: 12,
                      textDecoration: "none",
                      cursor: "pointer"
                    }}
                  >
                    Register for free
                  </Link>
                </Box> */}
                <Box sx={{
                  mt: 1,
                  width: { xs: "100%", sm: "auto" },
                }}>
                  {/* Always visible part */}
                  <Typography variant="inherit" fontSize= "11px" color="primary" textAlign="justify" sx={{mx: 1}} >
                    By signing up to POISUM, I hereby consent to the use of my personal data by Gosum Consulting
                    Group Sdn. Bhd. in accordance with the{" "}
                    <Typography
                      component="span"
                      variant="inherit"
                      onClick={() => handleOpen("tnc")}
                      sx={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: "primary",
                      }}
                    >
                      <strong>Terms & Conditions</strong>
                    </Typography>{" "} and {" "}
                    <Typography
                      component="span"
                      variant="inherit"
                      onClick={() => handleOpen("privacy")}
                      sx={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: "primary",
                      }}
                    >
                      <strong>Privacy Policy</strong>
                    </Typography>
                    .
                  </Typography>
                </Box>
              </Stack>

              {errors.form && (
                <FormHelperText
                  sx={{
                    color: "error.main",
                    textAlign: "center",
                    marginTop: 2,
                  }}
                >
                  {errors.form}
                </FormHelperText>
              )}


            </Box>
            <ComponentBackdrop openBackdrop={openBackdrop} />
            {openTnc && (
              <Modal open={openTnc} onClose={() => handleClose("tnc")}>
                <Box
                  sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 2, // space outside modal (padding)
                    backgroundColor: "rgba(0, 0, 0, 0.4)", // optional: dimmed background
                  }}
                >
                  <Box
                    sx={{
                      maxHeight: "90vh",
                      width: "100%",
                      maxWidth: 900,
                      overflowY: "auto",
                      bgcolor: "background.paper",
                      border: "1px solid",
                      borderColor: "tertiary.dark",
                      boxShadow: 10,
                      p: 3,
                      borderRadius: 4,
                      scrollbarWidth: "none", // Firefox
                      msOverflowStyle: "none", // IE 10+
                      "&::-webkit-scrollbar": {
                        display: "none", // Chrome, Safari
                      },
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexDirection="row"
                    >
                      <Typography
                        variant={isMobile ? "body" : "subtitle"}
                        fontWeight="bold"
                        textTransform={"uppercase"}
                      >
                        POISUM’s Terms & Conditions
                      </Typography>
                      <CloseIcon
                        onClick={() => handleClose("tnc")}
                        sx={{ cursor: "pointer" }}
                      />
                    </Box>

                    <Divider sx={{ my: 3, borderColor: "tertiary.main" }} />

                    <Details />
                  </Box>
                </Box>
              </Modal>
            )}

            {openPolicy && (
              <Modal open={openPolicy} onClose={() => handleClose("privacy")}>
                <Box
                  sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 2, // space outside modal (padding)
                    backgroundColor: "rgba(0, 0, 0, 0.4)", // optional: dimmed background
                  }}
                >
                  <Box
                    sx={{
                      maxHeight: "90vh",
                      width: { xs: "100%", sm: 900 },
                      overflowY: "auto",
                      bgcolor: "background.paper",
                      border: "1px solid",
                      borderColor: "tertiary.dark",
                      boxShadow: 10,
                      p: 3,
                      borderRadius: 4,
                      scrollbarWidth: "none", // Firefox
                      msOverflowStyle: "none", // IE 10+
                      "&::-webkit-scrollbar": {
                        display: "none", // Chrome, Safari
                      },
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexDirection="row"
                    >
                      <Typography
                        variant={isMobile ? "body" : "subtitle"}
                        fontWeight="bold"
                        textTransform={"uppercase"}
                      >
                        POISUM’s Privacy Policy
                      </Typography>
                      <CloseIcon
                        onClick={() => handleClose("privacy")}
                        sx={{ cursor: "pointer" }}
                      />
                    </Box>

                    <Divider sx={{ my: 3, borderColor: "tertiary.main" }} />

                    <PrivacyPolicyModal />
                  </Box>
                </Box>
              </Modal>
            )}

          </Box>
        </Box>
      </Box>
      <Box
          component="img"
          src={poisum}
          alt="poisum"
          sx={{
              width:"100%",
              maxWidth:{ xs: "100%", md: 1000 },
              mt: { xs: -1.5, sm: -3.5, md: -6 }, // keep slight overlap
              mx: "auto",
              display: "block",
              opacity: 0.9, // optional like your screenshot
          }}
      />

      {/* <ForgotPassword open={dialogOpen} handleClose={handleDialogClose} setOpenBackdrop={setOpenBackdrop} /> */}
      <ComponentBackdrop openBackdrop={openBackdrop} />
    </PublicLayout>
  );
};

export default Signin;
